import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* About Section */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-widget">
                <h3>New Jeevan Deep</h3>
                <p>
                  Providing quality healthcare services with compassion and excellence. 
                  Your health is our priority. Book your appointment today for expert medical care.
                </p>
                <div className="social-links">
                  <a href="#"><FaFacebookF /></a>
                  <a href="#"><FaTwitter /></a>
                  <a href="#"><FaInstagram /></a>
                  <a href="#"><FaLinkedinIn /></a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <div className="footer-widget">
                <h4>Quick Links</h4>
                <ul className="footer-links">
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/doctors">Our Doctors</Link></li>
                  <li><Link to="/departments">Departments</Link></li>
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4>Our Services</h4>
                <ul className="footer-links">
                  <li><Link to="/departments/cardiology">Cardiology</Link></li>
                  <li><Link to="/departments/orthopedics">Orthopedics</Link></li>
                  <li><Link to="/departments/pediatrics">Pediatrics</Link></li>
                  <li><Link to="/departments/neurology">Neurology</Link></li>
                  <li><Link to="/book-appointment">Book Appointment</Link></li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-widget">
                <h4>Contact Us</h4>
                <div className="contact-info">
                  <p>
                    <FaMapMarkerAlt />
                    <span>Main Road, Ranchi,<br />Jharkhand, India</span>
                  </p>
                  <p>
                    <FaPhone />
                    <span>+91-651-XXXX-XXX</span>
                  </p>
                  <p>
                    <FaEnvelope />
                    <span>info@newjeevandeep.com</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} New Jeevan Deep Medical Center. All rights reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
